import { HttpParams, HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';
import { Observable, from, throwError, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Usuario } from '../models/usuario';


export interface ISignInCredentials {
  email: string;
  password: string;
}

export interface ICreateCredentials {
  email: string;
  password: string;
  displayName: string;
}

export interface IPasswordReset {
  code: string;
  newPassword: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private afAuth: AngularFireAuth, private http: HttpClient) { }

  signIn(credentials: ISignInCredentials): Observable<auth.UserCredential> {
    return from(this.afAuth.auth.signInWithEmailAndPassword(credentials.email, credentials.password));
  }

  signOut() {
    return from(this.afAuth.auth.signOut());
  }

  register(credentials: ICreateCredentials) {
    return from(
      this.afAuth.auth.createUserWithEmailAndPassword(credentials.email, credentials.password).then(
        () => {
          this.afAuth.auth.currentUser.updateProfile({ displayName: credentials.displayName });
          this.afAuth.auth.updateCurrentUser(this.afAuth.auth.currentUser);
        }
      )
    );
  }

  sendPasswordEmail(email) {
    return from(this.afAuth.auth.sendPasswordResetEmail(email));
  }

  resetPassword(credentials: IPasswordReset) {
    return from(this.afAuth.auth.confirmPasswordReset(credentials.code, credentials.newPassword));
  }

  get user(): firebase.User {
    return this.afAuth.auth.currentUser;
  }

  //Recupera usuario sql
  recuperaUsuario(usuario: Usuario) {
    var url = environment.apiUrl;
    let header = new HttpHeaders().append('Content-Type', 'application/json; charset=utf-8')

    return this.http.post<Usuario>((url + "/users/authenticate"), usuario, {
      headers: header
    });
  }

  async recuperaUsuarioToken(usuario = new Usuario()): Promise<Usuario> {
    const url = environment.apiUrl;
    let headers = new HttpHeaders().append('Content-Type', 'application/json; charset=utf-8');

    // Agregar el token en el header Authorization si está disponible
    if (usuario?.token) {
      headers = headers.append('Authorization', `Bearer ${usuario.token}`);
    } else {
      console.warn('⚠️ No se encontró token en el objeto usuario');
    }

    try {
      const response = await this.http.post<Usuario>((url + "/users/recuperaUsuarioConToken"), usuario, {
        headers: headers
      }).toPromise();

      return response;
    } catch (error) {
      // Manejo de errores, puedes personalizar esto según tus necesidades
      console.error("❌ Error recuperando el usuario con token", error);
      if (error?.error) {
        console.error("Detalles del error:", error.error);
      }
      if (error?.status) {
        console.error("Status code:", error.status);
      }
      throw error;
    }
  }

  // recuperaUsuarioToken(usuario: Usuario) {
  //   var url = environment.apiUrl;
  //   let header = new HttpHeaders().append('Content-Type', 'application/json; charset=utf-8')

  //   return this.http.post<Usuario>((url + "/users/recuperaUsuarioConToken"), usuario, {
  //     headers: header
  //   });
  // }

  login(responseUs: any): void {
    localStorage.setItem('usLog', JSON.stringify(responseUs));
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem("usLog");
  }

}
